import { render, staticRenderFns } from "./SubgroupRules.vue?vue&type=template&id=e4d03c46&scoped=true"
import script from "./SubgroupRules.vue?vue&type=script&lang=js"
export * from "./SubgroupRules.vue?vue&type=script&lang=js"
import style0 from "./SubgroupRules.vue?vue&type=style&index=0&id=e4d03c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d03c46",
  null
  
)

export default component.exports